import React from "react";
import Billing from "../../Components/B2B/billing";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const BillingPage = ({ match, location }) => {
  const query = queryString.parse(location.search);

  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <Billing date={query.date} />
    </React.Fragment>
  );
};

export default BillingPage;
